import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import './intranet.scss'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import IntranetStore from './IntranetStore'
import Page from './components/Page'
import AccessRights from '../AccessRights'
import ServiceStatusHeader from './components/ServiceStatusHeader'
import NewServiceStatusHeader from './components/ServiceStatusHeader/NewServiceStatusHeader'
import EmailSchedule from './components/EmailSchedule'
import MagicQuadrant from './components/MagicQuadrant'
import ApiKeys from './components/ApiKeys'
import SystemCompletedSurveys from './components/SystemCompletedSurveys'
import SystemResponseRate from './components/SystemResponseRate'
import SystemUniqueUsers from './components/SystemUniqueUsers'
import LicenceCounter from './components/LicenceCounter'
import SurveyTimeTracking from './components/SurveyTimeTracking'
import ProtectedRoute from '../../ProtectedRoute'
import LicenceManagerNew from './LicenceManagerNew'
import LicenceManager from './LicenceManager'
import EmailUsage from './components/EmailUsage'
import QuestionOptionLabels from './components/QuestionOptionLabels'
import SurveyDataImport from './components/SurveyDataImport'
import SystemUptime from './components/SystemUptime'
import NewExploriAdmin from './components/NewExploriAdmin'
import DataViewer from './components/Dataviewer'
import QueryRunner from './components/QueryRunner'
import QuestionImportExport from './components/QuestionImportExport'
import Metrics from './components/Metrics'
import Certification from './components/Certification'
import customTag from './components/CustomTag'
import MoveProductOrPortfolio from './components/MoveProductOrPortfolio'
import LoggedInUsers from './components/LoggedInUsers'
import PresentationAccessAdmin from './PresentationAccessAdmin'

import BubbleLoader from '../../UniformComponents/BubbleLoader'
import KpiCreator from './KpiCreator'
import AiSummaries from './components/AiSummaries/AiSummaries'

@observer
class Intranet extends Component {
    constructor(props) {
        super(props)
        const { store } = props
        this.intranetStore = new IntranetStore(store)

        console.log("intranet' constructor")

        this.intranetStore.isOnVPN()
        this.intranetStore.getLoggedinUsers()
    }

    showLoader = () => {
        const { intranetStore } = this
        const { isLoading } = intranetStore

        if (!isLoading) return false

        return (
            <Fragment>
                <div className="overlay" />
                <BubbleLoader cssClass="loader" />
            </Fragment>
        )
    }

    render() {
        const { store } = this.props
        const { intranetStore } = this
        const { isLoading } = intranetStore

        return (
            <div className="intranet">
                {this.showLoader()}
                {!isLoading && (
                    <Router>
                        <Switch>
                            <Route
                                path="/intranet/serviceStatus"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        {process.env.USE_NEW_HEADER_UI
                                            ? (
                                                <NewServiceStatusHeader
                                                    store={store}
                                                    intranetStore={this.intranetStore}
                                                />
                                            )
                                            : (
                                                <ServiceStatusHeader
                                                    store={store}
                                                    intranetStore={this.intranetStore}
                                                />
                                            )}
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/emailSchedule"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <EmailSchedule
                                            store={store}
                                            intranetStore={this.intranetStore}
                                        />
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/licences"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <LicenceManager
                                            store={store}
                                            intranetStore={this.intranetStore}
                                        />
                                    </AccessRights>
                                )}
                            />
                            {process.env.USE_NEW_LICENCE_MANAGER && (
                                <Route
                                    path="/intranet/licencemanager"
                                    render={() => (
                                        <AccessRights
                                            store={store}
                                            deniedRedirect="/home/e/01011"
                                        >
                                            <LicenceManagerNew
                                                appStore={store}
                                                intranetStore={this.intranetStore}
                                            />
                                        </AccessRights>
                                    )}
                                />
                            )}
                            <Route
                                path="/intranet/aiSummaries"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <AiSummaries store={intranetStore} />
                                    </AccessRights>
                                )}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isExploriSuper}
                                path="/intranet/completionTimeTracking"
                                title="Completion Time Tracking"
                                component={SurveyTimeTracking}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isExploriSuper}
                                path="/intranet/addNewExploriAdminUser"
                                title="Add new Explori Admin User"
                                component={NewExploriAdmin}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={() => (
                                    store.isExploriAdmin()
                                    || store.isExploriSuper()
                                )}
                                path="/intranet/dataViewer"
                                title="Data Viewer"
                                component={DataViewer}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={() => (
                                    store.isExploriAdmin()
                                    || store.isExploriSuper()
                                )}
                                path="/intranet/dataViewer2"
                                title="Data Viewer"
                                component={DataViewer}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isExploriSuper}
                                path="/intranet/queryrunner"
                                title="Query Runner"
                                component={QueryRunner}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isExploriSuper}
                                path="/intranet/questionImpEx"
                                title="Question Import/Export Tool"
                                component={QuestionImportExport}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isExploriSuper}
                                path="/intranet/certification"
                                title="Certification"
                                component={Certification}
                            />
                            <Route
                                path="/intranet/magicquadrant"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <MagicQuadrant store={store} />
                                    </AccessRights>
                                )}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isSuperUser}
                                path="/intranet/customTag"
                                title="Custom Tag"
                                component={customTag}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isSuperUser}
                                path="/intranet/kpiCreator"
                                title="KPI Creator"
                                component={KpiCreator}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isSuperUser}
                                path="/intranet/customBenchmark"
                                title="Custom Benchmark"
                                customBenchmark
                                component={customTag}
                            />
                            <Route
                                path="/intranet/apiKey"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <ApiKeys store={store} />
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/metrics"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <Metrics store={store} />
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/systemCompletedSurveys"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <SystemCompletedSurveys store={store} />
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/systemResponseRates"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <SystemResponseRate store={store} />
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/licencecounter"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <LicenceCounter store={store} />
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/systemUniqueUsers"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <SystemUniqueUsers store={store} />
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/emailusage"
                                render={() => (
                                    <EmailUsage intranetStore={this.intranetStore} />
                                )}
                            />
                            <Route
                                path="/intranet/questionoptionlangs"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <QuestionOptionLabels store={store} />
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/surveyDataImport"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <SurveyDataImport store={store} />
                                    </AccessRights>
                                )}
                            />
                            <Route
                                path="/intranet/uptime"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <SystemUptime store={store} />
                                    </AccessRights>
                                )}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isExploriSuper}
                                path="/intranet/moveProductOrPortfolioToNewClient"
                                title="Move product or portfolio to a new client"
                                component={MoveProductOrPortfolio}
                            />
                            <ProtectedRoute
                                store={store}
                                intranetStore={this.intranetStore}
                                roleRedirect="/home/e/01011"
                                customRule={store.isExploriAdmin}
                                path="/intranet/loggedInUsers"
                                title="Logged-in Users"
                                component={LoggedInUsers}
                            />
                            <ProtectedRoute
                                store={store}
                                roleRedirect="/home/e/01011"
                                customRule={store.isExploriAdmin}
                                path="/intranet/presentationAccessAdmin"
                                title="Presentation Access"
                                component={PresentationAccessAdmin}
                            />
                            <Route
                                path="/intranet"
                                render={() => (
                                    <AccessRights
                                        store={store}
                                        deniedRedirect="/home/e/01011"
                                    >
                                        <Page store={store} />
                                    </AccessRights>
                                )}
                            />
                        </Switch>
                    </Router>
                )}
            </div>
        )
    }
}
export default Intranet
